import React from 'react'
import type { ReactNode } from 'react'

interface ErrorBoundaryProps {
  children: ReactNode
  fallback?: ReactNode // 可自定义错误UI
}

interface ErrorBoundaryState {
  hasError: boolean
  error: Error | null
  errorInfo: React.ErrorInfo | null
}

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props)
    this.state = { hasError: false, error: null, errorInfo: null }
  }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { hasError: true, error, errorInfo: null }
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('@anker-in/headless-ui biz component ErrorBoundary caught an error:', error, errorInfo)
    this.setState({ errorInfo })
    // 可以在这里上报错误日志
  }

  render() {
    if (this.state.hasError) {
      // 使用自定义 fallback UI 或默认 UI
      if (this.props.fallback) return this.props.fallback
      // 只在开发模式显示错误
      return process.env.NODE_ENV === 'development' ? (
        <div style={{ padding: 20, textAlign: 'center' }}>
          <h1>something went wrong 😢</h1>
          <p>{this.state.error?.message}</p>
          <details style={{ whiteSpace: 'pre-wrap' }}>{this.state.errorInfo?.componentStack}</details>
        </div>
      ) : null
    }

    return this.props.children
  }
}

export default ErrorBoundary
